import React from 'react';
import {
  Button,
  Col,
  Container,
  Icon,
  Row,
  useApp,
  useUrlState
} from 'straightline-ui';
import { STATUS } from 'straightline-utils/constants';

import { ShipmentOffersList } from './list';

export default function ShipmentMatches(props) {
  const app = useApp();
  const urlState = useUrlState();

  const offers = app.service('api/shipment-offers').useFind(
    {
      $include: ['shipment'],
      query: {
        $limit: 25,
        $sort: { created_at: -1 },
        '$shipment.status_type$': STATUS.BOOKED,
        '$shipment.carrier_id$': null
      }
    },
    { keepPreviousData: true, refetchInterval: 60000 }
  );

  return (
    <Container fluid className="pb-5">
      <Row>
        <Col>
          <div className="header pt-md-2">
            <div className="header-body">
              <Row className="align-items-center justify-content-between">
                <Col xs="auto" className="mb-2 mb-lg-0">
                  <h6 className="header-pretitle">Overview</h6>
                  <h1 className="header-title">Load Offers</h1>
                </Col>
                <Col xs="auto">
                  <Row className="align-items-center justify-content-between">
                    <Col
                      className="mb-3 mb-sm-0"
                      style={{ maxWidth: 350 }}
                    ></Col>
                    <Col sm="auto">
                      <Button to="/shipment-matches" color="primary">
                        <Icon type="clipboard" className="mr-2" />
                        Load Board
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>

      <ShipmentOffersList offers={offers} queryState={urlState} />
    </Container>
  );
}
